const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const loadCaptchaScript = () => {
    if (!SITE_KEY || document.getElementById('recaptcha-script')) return;
    const script = document.createElement('script');
    script.id = 'recaptcha-script';
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    document.head.appendChild(script);
};

export const executeCaptcha = (action) =>
    new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(SITE_KEY, { action }).then(resolve).catch(reject);
        });
    });
